import { CSSProperties, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { Flex } from './Flex'

import { colors } from '@/constants'

const Wrapper = styled(Flex)`
  padding: 0.625rem;
  gap: 0.3125rem;
  align-items: center;
  border-radius: 9999px;
  background-color: ${colors.darkBlue1};
  border-width: 1px;
  border-color: ${colors.darkBlue3};
  box-shadow: 0px 30px 40px 0px #0000004d;
`

export default function InfoPill({
  children,
  wrapperStyle,
}: PropsWithChildren & { wrapperStyle?: CSSProperties }) {
  return <Wrapper style={wrapperStyle}>{children}</Wrapper>
}
